import { render, staticRenderFns } from "./ArtistLibrary.vue?vue&type=template&id=79420cd6&scoped=true"
import script from "./ArtistLibrary.vue?vue&type=script&lang=js"
export * from "./ArtistLibrary.vue?vue&type=script&lang=js"
import style0 from "./ArtistLibrary.vue?vue&type=style&index=0&id=79420cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79420cd6",
  null
  
)

export default component.exports